// src/project/data/triggers/markNotificationRead.js
// POST /message/mark/read/{notificationId}?group=ultraxeno
// Body: { userId }
import { buildActionUrl, getUserId } from '../config/apiConfig'

export default {
  postUrl(params) {
    const notifId = params?.notificationId || ''
    return buildActionUrl(`/message/mark/read/${notifId}`)
  },
  format(params) {
    return {
      userId: getUserId(),
    }
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Erreur lors du marquage',
        data: null,
      }
    }
    return {
      statusCode: 200,
      message: raw?.message || 'Notification marquée comme lue',
      data: null,
    }
  },
}
